import * as coreClient from "@azure/core-client";

export const PagedDevBox: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedDevBox",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBox",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBox: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBox",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      projectName: {
        serializedName: "projectName",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      poolName: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "poolName",
        required: true,
        type: {
          name: "String",
        },
      },
      hibernateSupport: {
        serializedName: "hibernateSupport",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled", "OsUnsupported"],
        },
      },
      provisioningState: {
        serializedName: "provisioningState",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Succeeded",
            "Failed",
            "Canceled",
            "Creating",
            "Deleting",
            "Updating",
            "Starting",
            "Stopping",
            "Provisioning",
            "ProvisionedWithWarning",
            "InGracePeriod",
            "NotProvisioned",
          ],
        },
      },
      actionState: {
        serializedName: "actionState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      powerState: {
        serializedName: "powerState",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Running",
            "Deallocated",
            "PoweredOff",
            "Hibernated",
          ],
        },
      },
      uniqueId: {
        serializedName: "uniqueId",
        readOnly: true,
        type: {
          name: "Uuid",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsError",
        },
      },
      location: {
        serializedName: "location",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      osType: {
        defaultValue: "Windows",
        isConstant: true,
        serializedName: "osType",
        type: {
          name: "String",
        },
      },
      user: {
        serializedName: "user",
        readOnly: true,
        type: {
          name: "Uuid",
        },
      },
      hardwareProfile: {
        serializedName: "hardwareProfile",
        type: {
          name: "Composite",
          className: "HardwareProfile",
        },
      },
      storageProfile: {
        serializedName: "storageProfile",
        type: {
          name: "Composite",
          className: "StorageProfile",
        },
      },
      imageReference: {
        serializedName: "imageReference",
        type: {
          name: "Composite",
          className: "ImageReference",
        },
      },
      createdTime: {
        serializedName: "createdTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      lastConnectedTime: {
        serializedName: "lastConnectedTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      localAdministrator: {
        serializedName: "localAdministrator",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
    },
  },
};

export const AzureCoreFoundationsError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AzureCoreFoundationsError",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        required: true,
        type: {
          name: "String",
        },
      },
      target: {
        serializedName: "target",
        type: {
          name: "String",
        },
      },
      details: {
        serializedName: "details",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AzureCoreFoundationsError",
            },
          },
        },
      },
      innererror: {
        serializedName: "innererror",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsInnerError",
        },
      },
    },
  },
};

export const AzureCoreFoundationsInnerError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AzureCoreFoundationsInnerError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "String",
        },
      },
      innererror: {
        serializedName: "innererror",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsInnerError",
        },
      },
    },
  },
};

export const HardwareProfile: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "HardwareProfile",
    modelProperties: {
      skuName: {
        serializedName: "skuName",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "general_i_8c32gb256ssd_v2",
            "general_i_8c32gb512ssd_v2",
            "general_i_8c32gb1024ssd_v2",
            "general_i_8c32gb2048ssd_v2",
            "general_i_16c64gb256ssd_v2",
            "general_i_16c64gb512ssd_v2",
            "general_i_16c64gb1024ssd_v2",
            "general_i_16c64gb2048ssd_v2",
            "general_i_32c128gb512ssd_v2",
            "general_i_32c128gb1024ssd_v2",
            "general_i_32c128gb2048ssd_v2",
            "general_a_8c32gb256ssd_v2",
            "general_a_8c32gb512ssd_v2",
            "general_a_8c32gb1024ssd_v2",
            "general_a_8c32gb2048ssd_v2",
            "general_a_16c64gb256ssd_v2",
            "general_a_16c64gb512ssd_v2",
            "general_a_16c64gb1024ssd_v2",
            "general_a_16c64gb2048ssd_v2",
            "general_a_32c128gb512ssd_v2",
            "general_a_32c128gb1024ssd_v2",
            "general_a_32c128gb2048ssd_v2",
          ],
        },
      },
      vCPUs: {
        serializedName: "vCPUs",
        readOnly: true,
        type: {
          name: "Number",
        },
      },
      memoryGB: {
        serializedName: "memoryGB",
        readOnly: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const StorageProfile: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StorageProfile",
    modelProperties: {
      osDisk: {
        serializedName: "osDisk",
        type: {
          name: "Composite",
          className: "OsDisk",
        },
      },
    },
  },
};

export const OsDisk: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OsDisk",
    modelProperties: {
      diskSizeGB: {
        serializedName: "diskSizeGB",
        readOnly: true,
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const ImageReference: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ImageReference",
    modelProperties: {
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "version",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      operatingSystem: {
        serializedName: "operatingSystem",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      osBuildNumber: {
        serializedName: "osBuildNumber",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      publishedDate: {
        serializedName: "publishedDate",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const AzureCoreFoundationsErrorResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AzureCoreFoundationsErrorResponse",
    modelProperties: {
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsError",
        },
      },
    },
  },
};

export const PagedProject: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedProject",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Project",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Project: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Project",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      maxDevBoxesPerUser: {
        constraints: {
          InclusiveMinimum: 0,
        },
        serializedName: "maxDevBoxesPerUser",
        type: {
          name: "Number",
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PagedCatalog: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedCatalog",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Catalog",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Catalog: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Catalog",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomizationTaskDefinition: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationTaskDefinition",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      catalogName: {
        serializedName: "catalogName",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      uri: {
        serializedName: "uri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "CustomizationTaskDefinitionParameter",
            },
          },
        },
      },
    },
  },
};

export const CustomizationTaskDefinitionParameter: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskDefinitionParameter",
      modelProperties: {
        description: {
          serializedName: "description",
          type: {
            name: "String",
          },
        },
        type: {
          serializedName: "type",
          required: true,
          type: {
            name: "Enum",
            allowedValues: ["string", "number", "boolean"],
          },
        },
        required: {
          serializedName: "required",
          readOnly: true,
          type: {
            name: "Boolean",
          },
        },
        default: {
          serializedName: "default",
          type: {
            name: "String",
          },
        },
        allowed: {
          serializedName: "allowed",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "String",
              },
            },
          },
        },
      },
    },
  };

export const PagedEnvironmentDefinition: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedEnvironmentDefinition",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentDefinition",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentDefinition: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentDefinition",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      catalogName: {
        serializedName: "catalogName",
        required: true,
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentDefinitionParameter",
            },
          },
        },
      },
      parametersSchema: {
        serializedName: "parametersSchema",
        type: {
          name: "String",
        },
      },
      templatePath: {
        serializedName: "templatePath",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentDefinitionParameter: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentDefinitionParameter",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      default: {
        serializedName: "default",
        type: {
          name: "String",
        },
      },
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "array",
            "boolean",
            "integer",
            "number",
            "object",
            "string",
          ],
        },
      },
      readOnly: {
        serializedName: "readOnly",
        type: {
          name: "Boolean",
        },
      },
      required: {
        serializedName: "required",
        required: true,
        type: {
          name: "Boolean",
        },
      },
      allowed: {
        constraints: {
          MinItems: 1,
        },
        serializedName: "allowed",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const PagedCustomizationTaskDefinition: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedCustomizationTaskDefinition",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomizationTaskDefinition",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomizationTaskList: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationTaskList",
    modelProperties: {
      tasks: {
        serializedName: "tasks",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomizationTask",
            },
          },
        },
      },
    },
  },
};

export const CustomizationTask: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationTask",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
      timeoutInSeconds: {
        serializedName: "timeoutInSeconds",
        type: {
          name: "Number",
        },
      },
      runAs: {
        serializedName: "runAs",
        type: {
          name: "Enum",
          allowedValues: ["System", "User"],
        },
      },
      id: {
        serializedName: "id",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      logUri: {
        serializedName: "logUri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "FailedValidation",
            "Skipped",
            "TimedOut",
            "Failed",
            "WaitingForUserInputUac",
            "WaitingForUserSession",
          ],
        },
      },
      startTime: {
        serializedName: "startTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const CustomizationTaskListValidationOperationResult: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskListValidationOperationResult",
      modelProperties: {
        id: {
          serializedName: "id",
          required: true,
          readOnly: true,
          type: {
            name: "String",
          },
        },
        name: {
          serializedName: "name",
          required: true,
          readOnly: true,
          type: {
            name: "Uuid",
          },
        },
        status: {
          serializedName: "status",
          required: true,
          type: {
            name: "Enum",
            allowedValues: [
              "NotStarted",
              "Running",
              "Succeeded",
              "Failed",
              "Canceled",
            ],
          },
        },
        resourceId: {
          serializedName: "resourceId",
          type: {
            name: "String",
          },
        },
        startTime: {
          serializedName: "startTime",
          type: {
            name: "DateTime",
          },
        },
        endTime: {
          serializedName: "endTime",
          type: {
            name: "DateTime",
          },
        },
        percentComplete: {
          constraints: {
            InclusiveMaximum: 100,
            InclusiveMinimum: 0,
          },
          serializedName: "percentComplete",
          type: {
            name: "Number",
          },
        },
        properties: {
          serializedName: "properties",
          type: {
            name: "any",
          },
        },
        error: {
          serializedName: "error",
          type: {
            name: "Composite",
            className: "AzureCoreFoundationsError",
          },
        },
        result: {
          serializedName: "result",
          type: {
            name: "Composite",
            className: "CustomizationTaskListValidationResult",
          },
        },
      },
    },
  };

export const CustomizationTaskListValidationResult: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskListValidationResult",
      modelProperties: {
        validationResult: {
          serializedName: "validationResult",
          required: true,
          type: {
            name: "Enum",
            allowedValues: ["Succeeded", "Failed"],
          },
        },
        errors: {
          serializedName: "errors",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "CustomizationTaskListValidationError",
              },
            },
          },
        },
      },
    },
  };

export const CustomizationTaskListValidationError: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomizationTaskListValidationError",
      modelProperties: {
        target: {
          serializedName: "target",
          type: {
            name: "Composite",
            className: "CustomizationTask",
          },
        },
        details: {
          serializedName: "details",
          required: true,
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "AzureCoreFoundationsError",
              },
            },
          },
        },
      },
    },
  };

export const PagedEnvironmentType: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedEnvironmentType",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentType",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentType: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentType",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      deploymentTargetId: {
        serializedName: "deploymentTargetId",
        required: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentTypeAbilities: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentTypeAbilities",
    modelProperties: {
      abilitiesAsAdmin: {
        serializedName: "abilitiesAsAdmin",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "DeleteEnvironments",
                "ManageEnvironmentActions",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
      abilitiesAsDeveloper: {
        serializedName: "abilitiesAsDeveloper",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "DeleteEnvironments",
                "ManageEnvironmentActions",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
    },
  },
};

export const PagedEnvironment: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedEnvironment",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Environment",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Environment: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Environment",
    modelProperties: {
      expirationDate: {
        serializedName: "expirationDate",
        type: {
          name: "DateTime",
        },
      },
      parameters: {
        serializedName: "parameters",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      uri: {
        serializedName: "uri",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      environmentType: {
        serializedName: "environmentType",
        required: true,
        type: {
          name: "String",
        },
      },
      user: {
        serializedName: "user",
        readOnly: true,
        type: {
          name: "Uuid",
        },
      },
      provisioningState: {
        serializedName: "provisioningState",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Succeeded",
            "Failed",
            "Canceled",
            "Creating",
            "Accepted",
            "Deleting",
            "Updating",
            "Preparing",
            "Running",
            "Syncing",
            "MovingResources",
            "TransientFailure",
            "StorageProvisioningFailed",
          ],
        },
      },
      resourceGroupId: {
        serializedName: "resourceGroupId",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      catalogName: {
        serializedName: "catalogName",
        required: true,
        type: {
          name: "String",
        },
      },
      environmentDefinitionName: {
        serializedName: "environmentDefinitionName",
        required: true,
        type: {
          name: "String",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsError",
        },
      },
    },
  },
};

export const OperationStatus: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OperationStatus",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "Uuid",
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "Failed",
            "Canceled",
          ],
        },
      },
      resourceId: {
        serializedName: "resourceId",
        type: {
          name: "String",
        },
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime",
        },
      },
      percentComplete: {
        constraints: {
          InclusiveMaximum: 100,
          InclusiveMinimum: 0,
        },
        serializedName: "percentComplete",
        type: {
          name: "Number",
        },
      },
      properties: {
        serializedName: "properties",
        type: {
          name: "any",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsError",
        },
      },
    },
  },
};

export const PagedPool: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedPool",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Pool",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Pool: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Pool",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      location: {
        serializedName: "location",
        required: true,
        type: {
          name: "String",
        },
      },
      osType: {
        defaultValue: "Windows",
        isConstant: true,
        serializedName: "osType",
        type: {
          name: "String",
        },
      },
      hardwareProfile: {
        serializedName: "hardwareProfile",
        type: {
          name: "Composite",
          className: "HardwareProfile",
        },
      },
      hibernateSupport: {
        serializedName: "hibernateSupport",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled", "OsUnsupported"],
        },
      },
      storageProfile: {
        serializedName: "storageProfile",
        type: {
          name: "Composite",
          className: "StorageProfile",
        },
      },
      imageReference: {
        serializedName: "imageReference",
        type: {
          name: "Composite",
          className: "ImageReference",
        },
      },
      localAdministrator: {
        serializedName: "localAdministrator",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
      stopOnDisconnect: {
        serializedName: "stopOnDisconnect",
        type: {
          name: "Composite",
          className: "StopOnDisconnectConfiguration",
        },
      },
      stopOnNoConnect: {
        serializedName: "stopOnNoConnect",
        type: {
          name: "Composite",
          className: "StopOnNoConnectConfiguration",
        },
      },
      healthStatus: {
        serializedName: "healthStatus",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "Pending",
            "Healthy",
            "Warning",
            "Unhealthy",
          ],
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const StopOnDisconnectConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StopOnDisconnectConfiguration",
    modelProperties: {
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
      gracePeriodMinutes: {
        serializedName: "gracePeriodMinutes",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const StopOnNoConnectConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StopOnNoConnectConfiguration",
    modelProperties: {
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"],
        },
      },
      gracePeriodMinutes: {
        serializedName: "gracePeriodMinutes",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const PagedSchedule: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedSchedule",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Schedule",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Schedule: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Schedule",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      sourceUri: {
        serializedName: "sourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceType: {
        defaultValue: "Pool",
        isConstant: true,
        serializedName: "sourceType",
        type: {
          name: "String",
        },
      },
      type: {
        defaultValue: "StopDevBox",
        isConstant: true,
        serializedName: "type",
        type: {
          name: "String",
        },
      },
      frequency: {
        defaultValue: "Daily",
        isConstant: true,
        serializedName: "frequency",
        type: {
          name: "String",
        },
      },
      time: {
        serializedName: "time",
        required: true,
        type: {
          name: "String",
        },
      },
      timeZone: {
        serializedName: "timeZone",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ProjectAbilities: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ProjectAbilities",
    modelProperties: {
      abilitiesAsAdmin: {
        serializedName: "abilitiesAsAdmin",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "DeleteDevBoxes",
                "DeleteEnvironments",
                "ManageEnvironmentActions",
                "ReadDevBoxes",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "StartDevBoxes",
                "StopDevBoxes",
                "WriteDevBoxes",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
      abilitiesAsDeveloper: {
        serializedName: "abilitiesAsDeveloper",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Enum",
              allowedValues: [
                "CustomizeDevBoxes",
                "DeleteDevBoxes",
                "DeleteEnvironments",
                "ManageDevBoxActions",
                "ManageEnvironmentActions",
                "ReadDevBoxActions",
                "ReadDevBoxes",
                "ReadEnvironmentActions",
                "ReadEnvironmentOutputs",
                "ReadEnvironments",
                "ReadRemoteConnections",
                "StartDevBoxes",
                "StopDevBoxes",
                "WriteDevBoxes",
                "WriteEnvironments",
              ],
            },
          },
        },
      },
    },
  },
};

export const PagedDevBoxAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedDevBoxAction",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBoxAction",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxAction",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      actionType: {
        defaultValue: "Stop",
        isConstant: true,
        serializedName: "actionType",
        type: {
          name: "String",
        },
      },
      sourceId: {
        serializedName: "sourceId",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceUri: {
        serializedName: "sourceUri",
        required: true,
        type: {
          name: "String",
        },
      },
      sourceType: {
        serializedName: "sourceType",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Pool", "Schedule"],
        },
      },
      suspendedUntil: {
        serializedName: "suspendedUntil",
        type: {
          name: "DateTime",
        },
      },
      next: {
        serializedName: "next",
        type: {
          name: "Composite",
          className: "DevBoxNextAction",
        },
      },
    },
  },
};

export const DevBoxNextAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxNextAction",
    modelProperties: {
      scheduledTime: {
        serializedName: "scheduledTime",
        required: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const PagedDevBoxActionDelayResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedDevBoxActionDelayResult",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBoxActionDelayResult",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxActionDelayResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxActionDelayResult",
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String",
        },
      },
      result: {
        serializedName: "result",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Succeeded", "Failed"],
        },
      },
      action: {
        serializedName: "action",
        type: {
          name: "Composite",
          className: "DevBoxAction",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsError",
        },
      },
    },
  },
};

export const PagedCustomizationGroup: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedCustomizationGroup",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomizationGroup",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomizationGroup: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomizationGroup",
    modelProperties: {
      tasks: {
        serializedName: "tasks",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomizationTask",
            },
          },
        },
      },
      uri: {
        serializedName: "uri",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      status: {
        serializedName: "status",
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "Failed",
            "ValidationFailed",
          ],
        },
      },
      startTime: {
        serializedName: "startTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const PagedDevBoxOperation: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedDevBoxOperation",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBoxOperation",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxOperation: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: {
      serializedName: "kind",
      clientName: "kind",
    },
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationId: {
        serializedName: "operationId",
        required: true,
        readOnly: true,
        type: {
          name: "Uuid",
        },
      },
      kind: {
        serializedName: "kind",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "Start",
            "Stop",
            "Restart",
            "Repair",
            "RestoreSnapshot",
            "CaptureSnapshot",
          ],
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "Failed",
            "Canceled",
          ],
        },
      },
      createdByObjectId: {
        serializedName: "createdByObjectId",
        type: {
          name: "Uuid",
        },
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime",
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsError",
        },
      },
    },
  },
};

export const RemoteConnection: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RemoteConnection",
    modelProperties: {
      webUrl: {
        serializedName: "webUrl",
        type: {
          name: "String",
        },
      },
      rdpConnectionUrl: {
        serializedName: "rdpConnectionUrl",
        type: {
          name: "String",
        },
      },
      cloudPcConnectionUrl: {
        serializedName: "cloudPcConnectionUrl",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PagedDevBoxSnapshot: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedDevBoxSnapshot",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DevBoxSnapshot",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxSnapshot: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxSnapshot",
    modelProperties: {
      snapshotId: {
        serializedName: "snapshotId",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      createdTime: {
        serializedName: "createdTime",
        required: true,
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      expirationTime: {
        serializedName: "expirationTime",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      snapshotType: {
        serializedName: "snapshotType",
        required: true,
        readOnly: true,
        type: {
          name: "Enum",
          allowedValues: ["Manual", "Automatic"],
        },
      },
    },
  },
};

export const EnvironmentPatchProperties: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentPatchProperties",
    modelProperties: {
      expirationDate: {
        serializedName: "expirationDate",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const PagedEnvironmentAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedEnvironmentAction",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentAction",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentAction",
    modelProperties: {
      name: {
        constraints: {
          Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
          MaxLength: 63,
          MinLength: 3,
        },
        serializedName: "name",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      uri: {
        serializedName: "uri",
        required: true,
        readOnly: true,
        type: {
          name: "String",
        },
      },
      actionType: {
        defaultValue: "Delete",
        isConstant: true,
        serializedName: "actionType",
        type: {
          name: "String",
        },
      },
      next: {
        serializedName: "next",
        type: {
          name: "Composite",
          className: "EnvironmentNextAction",
        },
      },
      lastModifiedBy: {
        serializedName: "lastModifiedBy",
        readOnly: true,
        type: {
          name: "Uuid",
        },
      },
      lastModifiedAt: {
        serializedName: "lastModifiedAt",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const EnvironmentNextAction: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentNextAction",
    modelProperties: {
      scheduledTime: {
        serializedName: "scheduledTime",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const PagedEnvironmentOperation: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PagedEnvironmentOperation",
    modelProperties: {
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EnvironmentOperation",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnvironmentOperation: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentOperation",
    uberParent: "EnvironmentOperation",
    polymorphicDiscriminator: {
      serializedName: "kind",
      clientName: "kind",
    },
    modelProperties: {
      uri: {
        serializedName: "uri",
        required: true,
        type: {
          name: "String",
        },
      },
      operationId: {
        serializedName: "operationId",
        required: true,
        readOnly: true,
        type: {
          name: "Uuid",
        },
      },
      kind: {
        serializedName: "kind",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Deploy", "Delete"],
        },
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [
            "NotStarted",
            "Running",
            "Succeeded",
            "Failed",
            "Canceled",
          ],
        },
      },
      createdByObjectId: {
        serializedName: "createdByObjectId",
        type: {
          name: "Uuid",
        },
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime",
        },
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime",
        },
      },
      environmentParameters: {
        serializedName: "environmentParameters",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "AzureCoreFoundationsError",
        },
      },
    },
  },
};

export const EnvironmentOutputs: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentOutputs",
    modelProperties: {
      outputs: {
        serializedName: "outputs",
        type: {
          name: "Dictionary",
          value: {
            type: { name: "Composite", className: "EnvironmentOutput" },
          },
        },
      },
    },
  },
};

export const EnvironmentOutput: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EnvironmentOutput",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "Enum",
          allowedValues: ["array", "boolean", "number", "object", "string"],
        },
      },
      value: {
        serializedName: "value",
        type: {
          name: "any",
        },
      },
      sensitive: {
        serializedName: "sensitive",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const DevBoxRepairOperationResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxRepairOperationResult",
    modelProperties: {
      repairOutcome: {
        serializedName: "repairOutcome",
        type: {
          name: "Enum",
          allowedValues: ["FixApplied", "IssuesDetected", "NoIssuesDetected"],
        },
      },
      code: {
        serializedName: "code",
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxCaptureSnapshotOperation: coreClient.CompositeMapper = {
  serializedName: "CaptureSnapshot",
  type: {
    name: "Composite",
    className: "DevBoxCaptureSnapshotOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
    },
  },
};

export const DevBoxRepairOperation: coreClient.CompositeMapper = {
  serializedName: "Repair",
  type: {
    name: "Composite",
    className: "DevBoxRepairOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
      result: {
        serializedName: "result",
        type: {
          name: "Composite",
          className: "DevBoxRepairOperationResult",
        },
      },
    },
  },
};

export const DevBoxRestartOperation: coreClient.CompositeMapper = {
  serializedName: "Restart",
  type: {
    name: "Composite",
    className: "DevBoxRestartOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
    },
  },
};

export const DevBoxRestoreSnapshotOperation: coreClient.CompositeMapper = {
  serializedName: "RestoreSnapshot",
  type: {
    name: "Composite",
    className: "DevBoxRestoreSnapshotOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
      snapshotId: {
        serializedName: "snapshotId",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxStartOperation: coreClient.CompositeMapper = {
  serializedName: "Start",
  type: {
    name: "Composite",
    className: "DevBoxStartOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
    },
  },
};

export const DevBoxStopOperation: coreClient.CompositeMapper = {
  serializedName: "Stop",
  type: {
    name: "Composite",
    className: "DevBoxStopOperation",
    uberParent: "DevBoxOperation",
    polymorphicDiscriminator: DevBoxOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...DevBoxOperation.type.modelProperties,
    },
  },
};

export const EnvironmentDeleteOperation: coreClient.CompositeMapper = {
  serializedName: "Delete",
  type: {
    name: "Composite",
    className: "EnvironmentDeleteOperation",
    uberParent: "EnvironmentOperation",
    polymorphicDiscriminator:
      EnvironmentOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...EnvironmentOperation.type.modelProperties,
    },
  },
};

export const EnvironmentDeployOperation: coreClient.CompositeMapper = {
  serializedName: "Deploy",
  type: {
    name: "Composite",
    className: "EnvironmentDeployOperation",
    uberParent: "EnvironmentOperation",
    polymorphicDiscriminator:
      EnvironmentOperation.type.polymorphicDiscriminator,
    modelProperties: {
      ...EnvironmentOperation.type.modelProperties,
    },
  },
};

export const DevBoxesListAllDevBoxesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListAllDevBoxesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetCustomizationTaskDefinitionsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetCustomizationTaskDefinitionsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListCustomizationTaskDefinitionsByProjectExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "DevBoxesListCustomizationTaskDefinitionsByProjectExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesValidateCustomizationTasksActionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesValidateCustomizationTasksActionHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
        operationLocation: {
          serializedName: "operation-location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesValidateCustomizationTasksActionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesValidateCustomizationTasksActionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetImagingTaskLogExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetImagingTaskLogExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListPoolsExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesListPoolsExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesGetPoolExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesGetPoolExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesListSchedulesByPoolExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByPoolExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetScheduleByPoolExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetScheduleByPoolExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSchedulesByProjectExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByProjectExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListDevBoxesByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListDevBoxesByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetDevBoxByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetDevBoxByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesCreateDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesCreateDevBoxHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesCreateDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesCreateDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesDeleteDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesDeleteDevBoxHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesDeleteDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesDeleteDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesStartDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStartDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesStartDevBoxExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStartDevBoxExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesStopDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStopDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesStopDevBoxExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesStopDevBoxExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesRestartDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesRestartDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesRestartDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesRestartDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesRepairDevBoxHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesRepairDevBoxHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesRepairDevBoxExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesRepairDevBoxExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesRestoreSnapshotHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesRestoreSnapshotHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesRestoreSnapshotExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesRestoreSnapshotExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesCaptureSnapshotHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesCaptureSnapshotHeaders",
    modelProperties: {
      operationLocation: {
        serializedName: "operation-location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesCaptureSnapshotExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesCaptureSnapshotExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListActionsExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesListActionsExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesGetActionExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesGetActionExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesSkipActionExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesSkipActionExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesDelayActionExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesDelayActionExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesDelayActionsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesDelayActionsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListCustomizationGroupsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListCustomizationGroupsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetCustomizationGroupExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetCustomizationGroupExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesCreateCustomizationGroupExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesCreateCustomizationGroupExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetCustomizationTaskLogExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetCustomizationTaskLogExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListOperationsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListOperationsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetOperationExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetOperationExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetRemoteConnectionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesGetRemoteConnectionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSnapshotsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSnapshotsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesGetSnapshotExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevBoxesGetSnapshotExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevBoxesListAllDevBoxesByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListAllDevBoxesByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListAllDevBoxesNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListAllDevBoxesNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListCustomizationTaskDefinitionsByProjectNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "DevBoxesListCustomizationTaskDefinitionsByProjectNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListPoolsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListPoolsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSchedulesByPoolNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByPoolNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSchedulesByProjectNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSchedulesByProjectNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListDevBoxesByUserNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListDevBoxesByUserNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListActionsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListActionsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesDelayActionsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesDelayActionsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListCustomizationGroupsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListCustomizationGroupsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListOperationsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListOperationsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListSnapshotsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListSnapshotsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevBoxesListAllDevBoxesByUserNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevBoxesListAllDevBoxesByUserNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterListProjectsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterListProjectsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterGetProjectExceptionHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DevCenterGetProjectExceptionHeaders",
    modelProperties: {
      xMsErrorCode: {
        serializedName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DevCenterGetProjectAbilitiesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterGetProjectAbilitiesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DevCenterListProjectsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DevCenterListProjectsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListCatalogsByProjectExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListCatalogsByProjectExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetCatalogExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetCatalogExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByCatalogExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByCatalogExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentDefinitionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentDefinitionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByProjectExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByProjectExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentTypesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentTypesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentTypesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentTypesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentTypeAbilitiesExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentTypeAbilitiesExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetEnvironmentByUserExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetEnvironmentByUserExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsCreateOrReplaceEnvironmentHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsCreateOrReplaceEnvironmentHeaders",
      modelProperties: {
        operationLocation: {
          serializedName: "operation-location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsCreateOrReplaceEnvironmentExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsCreateOrReplaceEnvironmentExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsPatchEnvironmentExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsPatchEnvironmentExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsDeleteEnvironmentHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsDeleteEnvironmentHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
        operationLocation: {
          serializedName: "operation-location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsDeleteEnvironmentExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsDeleteEnvironmentExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListActionsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListActionsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetActionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetActionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsSkipActionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsSkipActionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsDelayActionExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsDelayActionExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListOperationsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListOperationsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetOperationExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetOperationExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetLogsByOperationExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetLogsByOperationExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsGetOutputsExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsGetOutputsExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListCatalogsByProjectNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListCatalogsByProjectNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByCatalogNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByCatalogNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentDefinitionsByProjectNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className:
        "EnvironmentsListEnvironmentDefinitionsByProjectNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentTypesNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentTypesNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListEnvironmentsByUserNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListEnvironmentsByUserNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListActionsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListActionsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EnvironmentsListOperationsNextExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "EnvironmentsListOperationsNextExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const OperationStatusesGetExceptionHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "OperationStatusesGetExceptionHeaders",
      modelProperties: {
        xMsErrorCode: {
          serializedName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export let discriminators = {
  DevBoxOperation: DevBoxOperation,
  EnvironmentOperation: EnvironmentOperation,
  "DevBoxOperation.CaptureSnapshot": DevBoxCaptureSnapshotOperation,
  "DevBoxOperation.Repair": DevBoxRepairOperation,
  "DevBoxOperation.Restart": DevBoxRestartOperation,
  "DevBoxOperation.RestoreSnapshot": DevBoxRestoreSnapshotOperation,
  "DevBoxOperation.Start": DevBoxStartOperation,
  "DevBoxOperation.Stop": DevBoxStopOperation,
  "EnvironmentOperation.Delete": EnvironmentDeleteOperation,
  "EnvironmentOperation.Deploy": EnvironmentDeployOperation,
};
